import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type BindEthAddressRequest = {
  /**  style id */
  ethAddress: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export type BindEthAddressSimpleRequest = {
  /**  style id */
  ethAddress: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BindTwitterUserInfoRequest = {
  /**  style id */
  code: Scalars['String']['input'];
  /**  is public */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanResponse = {
  data?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ClaimRequest = {
  app: Scalars['String']['input'];
  bizId?: InputMaybe<Scalars['String']['input']>;
  bizType?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  templateCode: Scalars['String']['input'];
};

export type CommonPageDto = {
  pageNum?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskPagination = {
  items?: Maybe<Array<Maybe<FriendTaskStatus>>>;
  pagination?: Maybe<CommonPageDto>;
};

export type FriendTaskStatus = {
  address?: Maybe<Scalars['String']['output']>;
  inWhiteList?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type FriendTaskStatusPageList = {
  data?: Maybe<FriendTaskPagination>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type FriendsTaskStatusPageQueryRequest = {
  page: Scalars['String']['input'];
  pageSize: Scalars['String']['input'];
};

export type InvitingUserQualifiedResponse = {
  data?: Maybe<InvitingUserQualifiedResponseVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type InvitingUserQualifiedResponseVo = {
  qualifiedCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
};

export type LoginReq = {
  /**  is public */
  ethAddress: Scalars['String']['input'];
  invitedCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**  style id */
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResult = {
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LoginResultResponse = {
  data?: Maybe<LoginResult>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type LoginWithTgReq = {
  /**  style id */
  tgId: Scalars['String']['input'];
  /**  is public */
  tgUserInfoStr?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  bindEthAddress?: Maybe<BooleanResponse>;
  bindEthAddressSimple?: Maybe<BooleanResponse>;
  bindTwitterUserInfo?: Maybe<BooleanResponse>;
  claim?: Maybe<BooleanResponse>;
  login?: Maybe<LoginResultResponse>;
  loginWithTg?: Maybe<LoginResultResponse>;
};


export type MutationBindEthAddressArgs = {
  req: BindEthAddressRequest;
};


export type MutationBindEthAddressSimpleArgs = {
  req: BindEthAddressSimpleRequest;
};


export type MutationBindTwitterUserInfoArgs = {
  req: BindTwitterUserInfoRequest;
};


export type MutationClaimArgs = {
  req: ClaimRequest;
};


export type MutationLoginArgs = {
  req: LoginReq;
};


export type MutationLoginWithTgArgs = {
  req: LoginWithTgReq;
};

export type QualifiedFriendsQueryRequest = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  friendTaskStatusList?: Maybe<FriendTaskStatusPageList>;
  getNonce?: Maybe<StringResponse>;
  getQualifiedFriends?: Maybe<InvitingUserQualifiedResponse>;
  getRank?: Maybe<RankResponse>;
  getUserDetail?: Maybe<UserVoResponse>;
  getUserTaskRecords?: Maybe<TaskRecordListResponse>;
  getUserTaskTemplatesUse?: Maybe<TaskTemplateUseListResponse>;
  isUserInWhiteList?: Maybe<BooleanResponse>;
};


export type QueryFriendTaskStatusListArgs = {
  bizReq?: InputMaybe<FriendsTaskStatusPageQueryRequest>;
};


export type QueryGetNonceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQualifiedFriendsArgs = {
  bizReq?: InputMaybe<QualifiedFriendsQueryRequest>;
};


export type QueryGetUserDetailArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserTaskRecordsArgs = {
  bizReq?: InputMaybe<TaskQueryRequest>;
};


export type QueryGetUserTaskTemplatesUseArgs = {
  bizReq?: InputMaybe<TaskQueryRequest>;
};


export type QueryIsUserInWhiteListArgs = {
  userId: Scalars['String']['input'];
};

export type RankResponse = {
  data?: Maybe<Array<Maybe<RankVo>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type RankVo = {
  cnt?: Maybe<Scalars['String']['output']>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoreInfo = {
  bizId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StringResponse = {
  data?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskRecord = {
  app?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  innerUser?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<Array<Maybe<ScoreInfo>>>;
  status?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskNo?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TaskRecordListResponse = {
  data?: Maybe<Array<Maybe<TaskRecord>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContent = {
  dailyTimesLimit?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  twitterName?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateContext = {
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUse = {
  content?: Maybe<TaskTemplateContent>;
  context?: Maybe<TaskTemplateContext>;
  taskCount?: Maybe<Scalars['String']['output']>;
  taskFinishCount?: Maybe<Scalars['String']['output']>;
  taskName?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateUseListResponse = {
  data?: Maybe<Array<Maybe<TaskTemplateUse>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type UserScoreInfo = {
  commonScore?: Maybe<Scalars['String']['output']>;
};

export type UserVo = {
  ethAddress?: Maybe<Scalars['String']['output']>;
  /**  user id */
  id?: Maybe<Scalars['String']['output']>;
  /**  user name */
  name?: Maybe<Scalars['String']['output']>;
  scoreInfo?: Maybe<UserScoreInfo>;
  /**  user status */
  status?: Maybe<Scalars['String']['output']>;
  tgId?: Maybe<Scalars['String']['output']>;
  xId?: Maybe<Scalars['String']['output']>;
};

export type UserVoResponse = {
  data?: Maybe<UserVo>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type TaskQueryRequest = {
  appToken?: InputMaybe<Scalars['String']['input']>;
  taskNos?: InputMaybe<Array<Scalars['String']['input']>>;
  templateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClaimMutationVariables = Exact<{
  req: ClaimRequest;
}>;


export type ClaimMutation = { claim?: { data?: boolean } };

export type GetNonceQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetNonceQuery = { getNonce?: { data?: string } };

export type GetUserDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserDetailQuery = { getUserDetail?: { success?: boolean, traceId?: string, data?: { ethAddress?: string, id?: string, name?: string, tgId?: string, xId?: string, status?: string, scoreInfo?: { commonScore?: string } } } };

export type GetUserTaskTemplatesUseQueryVariables = Exact<{
  appToken: Scalars['String']['input'];
}>;


export type GetUserTaskTemplatesUseQuery = { getUserTaskTemplatesUse?: { success?: boolean, traceId?: string, data?: Array<{ taskCount?: string, taskFinishCount?: string, taskName?: string, taskTemplateId?: string, taskType?: string, content?: { dailyTimesLimit?: number, twitterName?: string }, context?: { score?: string, scoreType?: string } }> } };

export type LoginMutationVariables = Exact<{
  req: LoginReq;
}>;


export type LoginMutation = { login?: { data?: { userId?: string, token?: string } } };


export const ClaimDocument = gql`
    mutation claim($req: ClaimRequest!) {
  claim(req: $req) {
    data
  }
}
    `;
export const GetNonceDocument = gql`
    query getNonce($address: String!) {
  getNonce(address: $address) {
    data
  }
}
    `;
export const GetUserDetailDocument = gql`
    query getUserDetail($id: String!) {
  getUserDetail(id: $id) {
    data {
      ethAddress
      id
      name
      scoreInfo {
        commonScore
      }
      tgId
      xId
      status
    }
    success
    traceId
  }
}
    `;
export const GetUserTaskTemplatesUseDocument = gql`
    query getUserTaskTemplatesUse($appToken: String!) {
  getUserTaskTemplatesUse(bizReq: {appToken: $appToken}) {
    data {
      content {
        dailyTimesLimit
        twitterName
      }
      context {
        score
        scoreType
      }
      taskCount
      taskFinishCount
      taskName
      taskTemplateId
      taskType
    }
    success
    traceId
  }
}
    `;
export const LoginDocument = gql`
    mutation login($req: LoginReq!) {
  login(req: $req) {
    data {
      userId
      token
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    claim(variables: ClaimMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ClaimMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClaimMutation>({ document: ClaimDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'claim', 'mutation', variables);
    },
    getNonce(variables: GetNonceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetNonceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNonceQuery>({ document: GetNonceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getNonce', 'query', variables);
    },
    getUserDetail(variables: GetUserDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserDetailQuery>({ document: GetUserDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserDetail', 'query', variables);
    },
    getUserTaskTemplatesUse(variables: GetUserTaskTemplatesUseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserTaskTemplatesUseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserTaskTemplatesUseQuery>({ document: GetUserTaskTemplatesUseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getUserTaskTemplatesUse', 'query', variables);
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'login', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;